import { render, staticRenderFns } from "./file-modal.vue?vue&type=template&id=6497f642&scoped=true&"
import script from "./file-modal.vue?vue&type=script&lang=js&"
export * from "./file-modal.vue?vue&type=script&lang=js&"
import style0 from "./file-modal.vue?vue&type=style&index=0&id=6497f642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6497f642",
  null
  
)

export default component.exports